module.exports = __webpack_public_path__ + "static/sui-table-sorting-c4b6e317505f2e06877fc221512b1641.png";